import {Chip, Typography, Stack} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useTranslator} from "../../context/TranslatorContext";

export default function CategoriesMandatoryDisplay(props) {
  const {messages} = useTranslator();
  const {mappings, defaultLanguage, topLabel, keywords, mediaType, modelFunction,
    lingualityType, msfunction, languageDependent, conformsTo, lrType, generationType} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  // console.log(props);
  return (
    <Stack sx={{pt: 1}} spacing={1}>
      {/* Pivot Language Heading */}
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      {!keywords.isEmpty() && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.keyword, "keyword")}
          </Typography>
          <div style={{display: "flex", gap: "0.3em", flexWrap: "wrap"}}>
            {keywords
                .getList()
                .map((item) => getLabel(item.getValue(defaultLanguage)))
                .filter((label) => label && label.trim() !== "")
                .map((label, index) => (
                  <Chip key={index} label={label} variant="outlined" />
                ))}
          </div>
        </div>
      )}
      {!isEmpty(mediaType.getList()) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.msmediaType, "mediaType")}
          </Typography>
          {mediaType.getList().map((item, index) => (
            <div key={index}>
              {getLabel(item.getValue(), "")}
            </div>
          ))}
        </div>
      )}

      {!isEmpty(modelFunction.getList()) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.modelFunction, "modelFunction")}
          </Typography>
          {modelFunction.getList().map((item, index) => (
            <div key={index}>
              <Typography variant="body1">{getLabel(item.getValue(), "")}</Typography>
            </div>
          ))}
        </div>
      )}
      {!isEmpty(conformsTo.getList()) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.conformsTo, "conformsTo")}
          </Typography>
          {conformsTo.getList().map((item, index) => (
            <div key={index}>
              <Typography variant="body1">{getLabel(item.getValue(), "")}</Typography>
            </div>
          ))}
        </div>
      )}
      {!isEmpty(getLabel(lingualityType.getValue())) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.lingualityType, "lingualityType")}
          </Typography>
          <Typography variant="body1">{getLabel(lingualityType.getValue())}</Typography>
        </div>
      )}
      {!isEmpty(getLabel(generationType.getValue())) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.generationType, "generationType")}
          </Typography>
          <Typography variant="body1">{getLabel(generationType.getValue())}</Typography>
        </div>
      )}
      {!isEmpty(msfunction.getList()) && (
        <div>
          <Typography variant="body2" className={"key"}>
            {getLabel(keys.msfunction, "msfunction")}
          </Typography>
          {msfunction.getList().map((item, index) => (
            <div key={index}>
              <Typography variant="body1">{getLabel(item.getValue(), "")}</Typography>
            </div>
          ))}
        </div>
      )}
      {lrType.includes("toolService") && languageDependent.getValue() !== undefined && languageDependent.getValue() !== null && (
        <div>
          <Typography variant="body1" className="key">
            {getLabel(keys.languageDependent, "languageDependent")}
          </Typography>
          <Chip
            label={languageDependent.getValue() ? messages.yes_message : messages.no_message}
            sx={{fontWeight: "600"}}
          />
        </div>
      )}
    </Stack>
  );
}
